import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AuthModal from './AuthModal';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const Layout = () => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user && user.emailVerified) {
        setCurrentUser(user);
        setShowAuthModal(false);
      } else {
        setCurrentUser(null);
      }
      setAuthChecked(true);
    });
    return () => unsubscribe();
  }, []);
  
  // Listen for custom event to open auth modal
  useEffect(() => {
    const handleOpenAuthModal = () => {
      setShowAuthModal(true);
    };
    
    window.addEventListener('open-auth-modal', handleOpenAuthModal);
    
    return () => {
      window.removeEventListener('open-auth-modal', handleOpenAuthModal);
    };
  }, []);

  useEffect(() => {
    if (!authChecked || !location || typeof location.pathname !== 'string') {
      return;
    }
    
    const path = location.pathname;
    
    const needsAuth = 
      path === '/profile' || 
      path === '/write' || 
      path === '/bookmarks' || 
      path.startsWith('/write/') || 
      path.startsWith('/bookmarks/');
    
    if (needsAuth && !currentUser) {
      setShowAuthModal(true);
    }
  }, [location, currentUser, authChecked]);

  if (!authChecked) {
    return (
      <>
        <Header
          openAuthModal={() => setShowAuthModal(true)}
          user={currentUser}
        />
        <main>
          <div style={{ height: '100vh' }}></div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header
        openAuthModal={() => setShowAuthModal(true)}
        user={currentUser}
      />
      <main>
        <Outlet />
      </main>
      <Footer />
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
      />
    </>
  );
};

export default Layout;
